module.exports = __webpack_public_path__ + "img/ico-graph.379d2027.svg";